import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import FlashMessages from '../../components/flashMessages.js';
import {_printNumber} from '../../helpers/helpers.js'
// https://www.freecodecamp.org/news/how-to-implement-vertical-scrolling-in-react-using-react-router-hash-link/
import { HashLink } from 'react-router-hash-link';

import {RtSubscriptionPlan, RtCreditPackage, RtPricingPageResult} from '../../../../server/routes/main.js'

// Interface for component props
interface PricingProps {
    server: string;
    pageData: unknown;
}

// Interface for subscription component props
interface SubscriptionProps {
    subscription: RtSubscriptionPlan;
    currentSubscription?: string;
}

// Interface for credit package component props
interface CreditPackageProps {
    creditPackage: RtCreditPackage;
}

const clrGreen = {
    color: 'white',
    backgroundColor: 'green'
};
const clrRed = {
    color: 'white',
    backgroundColor: 'red'
};


const clrGreenBk = {
    color: 'green'
 //   backgroundColor: '#f6576e'
};
const clrRedBk = {
    color: 'red'
 //   backgroundColor: '#f6576e'
};


export default function Price({server, pageData}: PricingProps) {
	let [data, setData] = useState(pageData as RtPricingPageResult);

    const [clientWindowHeight, setClientWindowHeight] = useState<string>("");

    function setVisibility(e: Element, yearlyState: boolean): void {
        let yearlElement = e.getAttribute('id') == undefined;
        let enabled = yearlElement == yearlyState;
        e.setAttribute('aria-hidden', enabled ? "false" : "true");      
    }
    function toggleAriaHidden(targets: NodeListOf<Element>, yearly: boolean): void {
        for (var z = 0; z < targets.length; z++) {
            for (var z = 0; z < targets.length; z++) {
                var   hiddenElements = targets[z].querySelectorAll('[aria-hidden="true"]'),
                    visibleElements = targets[z].querySelectorAll('[aria-hidden="false"]');
    
                for (var k = 0; k < hiddenElements.length; k++) {
                    setVisibility(hiddenElements[k],yearly);
                }
    
                for (var k = 0; k < visibleElements.length; k++) {
                    setVisibility(visibleElements[k],yearly);
                }
            }
        }
      }
      function toggleActive(e: Element): void {
        if (e.classList.contains('active')) {
            e.classList.remove('active');
        } else {
            e.classList.add('active');
        }
    }
    const handleClick = (e: Event): void => {
        let e1 = document.getElementById('pt-classic');
        let e2 = document.getElementById('pt-classic-toggle');
        let e3 = document.getElementById('togglebutton');
        if (e1) toggleActive(e1);
        if (e2) toggleActive(e2);
        if (e3) toggleActive(e3);
        let active = (e.target as Element).classList.contains('active');
        let yearly = active;

        if (e3) {
            let targets = document.querySelectorAll(e3.getAttribute('data-multitoggle-dm') || '');
            toggleAriaHidden(targets, yearly);
        }
    };
    
    useEffect(() => {
        let e = document.getElementById('togglebutton');
        if (e) {
            e.addEventListener('click', handleClick);
        }
        
        return () => {
            let e = document.getElementById('togglebutton');
            if (e != null) {
                e.removeEventListener('click', handleClick);                
            }
        }
    });

	return (
        <>
        <section className="section section-md bg-gray-100" id="plans">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <FlashMessages props={data} />
                    <div className="col-lg-12">
                        <h2 className="font-weight-light">Our Subscription Plans</h2>
                        <p className="text-muted mt-4 title-subtitle mx-auto">  
Our subscription plans provide API access and monthly Credits refills 
(<HashLink  smooth to="#creditspricing" ><u>Credits API pricing</u></HashLink>). 
Credits acquired through subscriptions expire one month after the subscription ends, 
while purchased Credits have a three-month expiration period from the date of purchase. </p>
                    </div>
                </div>   
                <div className="row justify-content-center text-center">
                    <div className="toggle-modern" aria-label="Pricing Switch Monthly/Yearly" id="pt-classic-toggle">
                        <div className="toggle-modern-text toggle-modern-text_default">Monthly</div>
                        <button id="togglebutton" className="toggle-modern-switch content-toggle" data-multitoggle-dm="#pt-classic, #pt-classic-toggle">
                            <span className="toggle-modern-switch-element"></span></button>
                        <div className="toggle-modern-text toggle-modern-text_alternate">Yearly</div>
                    </div> 
                </div>            
                <div className="row justify-content-center text-center  pt-classic-group" id="pt-classic">
                    {
                        data.Subscriptions.map((subscription: RtSubscriptionPlan, indexKey: number) => {
                            return <Subscription subscription={subscription} currentSubscription={data.CurrentSubscription!} key={indexKey}/>
                        })
                    }        
                </div>
            </div>
        </section>   
        {/*  
        <section className="section section-md bg-gray-100">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-12">
                        <h2 className="font-weight-light">Unlimited website technology lookups</h2>
                        <p className="text-muted mt-4 title-subtitle mx-auto">                     
                        For customers who only want to browse our data online (no API credits refill or included lead lists) to review website's metadata and technology stacks we offer a starter subscription plan with unlimited online technology lookups.
                        </p>
                    </div>
                </div>   
                <div className="row justify-content-center">
         
                    <div className="col-md-4 col-lg-4 col-xl-4">
                        <div className="bg-white mt-3 price-box">
                            <div className="pricing-name text-center">
                                <h4 className="mb-0">Unlimited lookups</h4>
                            </div>
                            <div className="plan-price text-center mt-4">
                                <h1 className="text-custom font-weight-normal mb-0">$15<span>/Month</span></h1>
                            </div>
                            <div className="text-center mt-5">
                                <a href="#" className="btn btn-custom text-white">Subscribe</a>
                            </div>
                        </div>
                    </div>          
                </div>                             
            </div>
        </section>  */}
        <section className="section section-md bg-gray-100" id="credits">
            <div className="container">
            <div className="row justify-content-center text-center">
                    <div className="col-lg-12">
                        <h2 className="font-weight-light">API Credits Pricing</h2>
                        <p className="text-muted mt-4 title-subtitle mx-auto">                     
                        For those seeking to avoid recurring fees, we offer the option of purchasing credits on a single-time basis.
                        </p>
                    </div>
                </div>
                <div className="row">
                {
                    data.CreditPackages.map((creditPackage: RtCreditPackage, indexKey: number) => {
                        return <CreditPackage creditPackage={creditPackage} key={indexKey}/>
                    })
                }
                </div>
            </div>
        </section>      
        <section className="section section-md bg-gray-100" id="credits">
            <div className="container">
            <div className="row justify-content-center text-center">
                    <div className="col-lg-12">
                        <h2 className="font-weight-light">API Endpoint Pricing Structure</h2>
                        <p className="text-muted mt-4 title-subtitle mx-auto">                     
                        The following table describes the number of credits deducted based on the type of API call.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-1 col-lg-2 col-xl-3"></div>
                    <CreditsUsage/>
                    <div className="col-md-1 col-lg-2 col-xl-3"></div>
                </div>
            </div>
        </section>      
       </>
    )
}

function CreditPackage({creditPackage}: CreditPackageProps) {

    return (
            <div className="col-md-4 col-lg-4 col-xl-4">
                <div className="bg-white mt-3 price-box">
                    <div className="pricing-name text-center">
                        <h4 className="mb-0">{_printNumber(creditPackage.Credits)} <br/> Credits</h4>
                    </div>
                    <div className="plan-price text-center mt-4">
                        <h1 className="text-custom font-weight-normal mb-0">${creditPackage.Price}<span></span></h1>
                    </div>
                    <div className="text-center mt-5">
                        <a href={`/purchase/credits?package=${creditPackage.Id}`} className="btn btn-custom text-white">Buy Now</a>
                    </div>
                </div>
            </div>
    )
}

function Subscription({subscription, currentSubscription}: SubscriptionProps) {

    const hasSubscription = !!currentSubscription;
    const isThisUserSubscription = subscription.Id == currentSubscription;

    function handleClick(e: React.MouseEvent): void {
        e.preventDefault();
        let ctrl = document.getElementById(`${subscription.Id}`);   // monthly
        let attr = ctrl?.getAttribute('aria-hidden');
        if (attr == 'true') {
            // yearly
            console.log('yearly sub');
            window.location.href = `/purchase/subscription?type=${subscription.Id}&yearly=1`;  
        } else {
            // monthly
            console.log('monthly sub');
            window.location.href = `/purchase/subscription?type=${subscription.Id}&yearly=0`;  
        }
      }

    return (
        <div className="col-md-4 col-lg-4 col-xl-4">
            <div className="bg-white mt-3 price-box">
                <div className="pricing-name text-center">
                    <h4 className="mb-0">{subscription.DisplayName}</h4>
                </div>
                
                <div className="pt-classic-price-outer ">
                    <div className="text-center" aria-hidden="false" id={subscription.Id}>
                        
                        <h1 className="text-custom font-weight-normal mb-0">
                            ${subscription.MonthlyPrice}
                        </h1><span>per Month</span>
                    </div>
                    <div className="text-center" aria-hidden="true">
                        <h1 className="text-custom font-weight-normal mb-0">
                            ${subscription.AnnualPrice}
                        </h1><span>per Year</span>
                    </div>                    
                </div>

                <div className="price-features mt-5 text-left">
                    <p><i className="mdi mdi-check" style={clrGreenBk}></i> 
                    Technology lookups: <span className="font-weight-bold">unlimited</span>
                    </p> 
                    <p><i className="mdi mdi-check" style={clrGreenBk}></i> 
                    API: <span className="font-weight-bold">included</span>
                    </p>  
                    <p><i className="mdi mdi-check" style={clrGreenBk}></i>
                    Credits: <span className="font-weight-bold">{_printNumber(subscription.MonthlyCredits)} per <br/> month  </span>
                    </p>
                </div>
                {
                    !hasSubscription && 
                    <>
                        <div className="text-center mt-5">
                            <a onClick={(e: React.MouseEvent) => handleClick(e)} href='#' className="btn btn-custom text-white">Subscribe</a>
                        </div>
                    </>
                }
                {
                    !!isThisUserSubscription && 
                    <div className="text-center mt-5">
                        <Link 
                            to={`/user/account`} 
                            className="btn btn-custom text-white"
                        >
                            Current Subscription
                        </Link>
                    </div>
                }
            </div>
        </div>
    )
}


function CreditsUsage() {
    return (
        <div className="col-md-10 col-lg-8 col-xl-6" id="creditspricing">
            <div className="bg-white mt-3 price-box">
                <table>
                    <thead>
                        <tr style={{backgroundColor: '#f9f8f8'}}>
                            <th style={{width: '50%'}}>API method</th>
                            <th style={{width: '50%'}}>Credits cost</th>
                        </tr>
                    </thead>   
                    <tbody>
                        <tr style={{backgroundColor: '#f0f0f0'}}>
                        <td>Domain lookup:</td><td>1 credit</td>
                        </tr> 
                        <tr style={{backgroundColor: '#f9f8f8'}}>
                        <td>Live domain scan:</td> <td>2 credits </td>
                        </tr>
                        <tr style={{backgroundColor: '#f9f8f8'}}>
                        <td>Subdomain lookup:</td> <td>1 credit per 10 subdomains</td>
                        </tr>
                        <tr style={{backgroundColor: '#f0f0f0'}}>
                        <td>Generate report:</td><td>1 credit per domain </td>
                        </tr>
                        <tr style={{backgroundColor: '#f9f8f8'}}>
                        <td>Test domain lookup:</td><td>free</td>
                        </tr>                         
                        <tr style={{backgroundColor: '#f0f0f0'}}>
                        <td>Get credits balance:</td><td>free </td>
                        </tr>
                    </tbody>           
                </table>
            </div>
        </div>
    )
}